import type { GetNotificationsQuery } from "types/graphql/graphql";

export type Notification =
  GetNotificationsQuery["notifications"]["list"][number];

export type NotificationData = {
  title: Record<string, string>;
  body: Record<string, string>;
  actionUrl?: string;
  icon?: string;
  category?: NotificationCategory;
  meta?: Record<string, unknown>;
};

/**
 * Mirrors backend's NotificationCategory enum.
 * Defined here because notification.data is JSONB (GraphQLJSON), not a typed GraphQL field.
 * @see pkgs/api/app/infrastructure/notification2-services/types.ts
 */
export type NotificationCategory =
  | "payment"
  | "kyb"
  | "kyc"
  | "benefit"
  | "employee"
  | "task"
  | "marketOrder"
  | "escalation"
  | "attributesCorrections"
  | "general";

export enum NotificationScreen {
  tasks = "tasks",
  kycRequest = "kyc-request",
  employmentDetails = "employment-details",
}

export type NotificationTargetRoute = {
  app: "admin" | "employee";
  screen?: NotificationScreen;
  role?: "platform" | "company" | "employee";
  taskId?: string;
  companyId?: string;
  employmentId?: string;
  productAssignmentId?: string;
  requestId?: string;
};
